import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { ConfigContext } from '../config-provider/ConfigProvider';
import defaultLocaleData from '../config-provider/locale/zh_CN';
var defaultConfigData = {
  locale: defaultLocaleData
};

var ConfigReceiverWrapper = function ConfigReceiverWrapper(name, defaultConfig) {
  return function InnerWrapper(WrappedComponent) {
    var ConfigReceiver = function ConfigReceiver(props) {
      return /*#__PURE__*/React.createElement(ConfigContext.Consumer, null, function (_ref) {
        var locale = _ref.locale;
        var globalLocale = locale.locale ? locale : (defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.locale) || (defaultConfigData === null || defaultConfigData === void 0 ? void 0 : defaultConfigData.locale);
        var componentLocale = globalLocale[name || WrappedComponent.name];
        var localeCode = globalLocale.locale;

        var forwardedRef = props.forwardedRef,
            rest = _objectWithoutProperties(props, ["forwardedRef"]);

        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, rest, {
          ref: forwardedRef,
          locale: componentLocale,
          localeCode: localeCode
        }));
      });
    };

    var forwardRef = function forwardRef(props, ref) {
      return /*#__PURE__*/React.createElement(ConfigReceiver, _extends({}, props, {
        forwardedRef: ref
      }));
    };

    var ConfigReceiverWithRef = /*#__PURE__*/React.forwardRef(forwardRef);
    hoistNonReactStatic(ConfigReceiverWithRef, WrappedComponent);
    return ConfigReceiverWithRef;
  };
};

export default ConfigReceiverWrapper;